import { Link } from 'react-router-dom';

export default function Article22() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <Link to="/blog" className="inline-block">
            <img 
              src="https://public.readdy.ai/ai/img_res/994872d3-d12a-41a9-b9a3-399c87796801.png" 
              alt="Practical Living Projects" 
              className="h-12 w-auto"
            />
          </Link>
        </div>
      </header>

      {/* Article Content */}
      <article className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/blog" className="inline-flex items-center text-base text-gray-600 hover:text-gray-900 mb-8 transition-colors cursor-pointer whitespace-nowrap">
          ← Back to articles
        </Link>

        <h1 className="text-5xl font-serif font-bold text-gray-900 mb-8 leading-tight">
          How Installers Ensure TVs Are Level, Secure, and Safe
        </h1>

        <div className="mb-12 overflow-hidden rounded-lg">
          <div className="w-full h-96 relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/e67a1b1c7194d56d588809fb1d90ad5f.jpg"
              alt="Professional installer using spirit level"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="prose prose-lg max-w-none">
          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            A professional TV installation involves more than attaching a bracket to the wall. Installers follow a series of checks to ensure the screen is level, securely fixed, and safe for long-term use.
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            The process begins with confirming wall structure and selecting fixings suitable for the surface. Installers use spirit levels and measurement tools to ensure precise alignment before tightening any hardware. This attention to detail prevents gradual movement or visible tilting over time.
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            Safety checks are also part of the process. Load ratings are confirmed, fixings are tested, and cable paths are planned so that cords are not under tension or exposed unnecessarily. These steps help reduce risks once the TV is in daily use.
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            Homeowners comparing installation services often refer to established directories such as: <a href="https://www.hotfrog.com.au/company/5891b49eb76262a9548c54a70d482a5f" className="text-gray-900 underline hover:text-gray-600 transition-colors cursor-pointer" target="_blank" rel="noopener noreferrer">https://www.hotfrog.com.au/company/5891b49eb76262a9548c54a70d482a5f</a>
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            For regulatory guidance related to residential building work in Victoria, information published by <a href="https://www.building.vic.gov.au/" className="text-gray-900 underline hover:text-gray-600 transition-colors cursor-pointer" target="_blank" rel="noopener noreferrer">Building Victoria</a> outlines expectations around safe and compliant installation practices.
          </p>

          <div className="my-12 border border-gray-200 rounded-lg overflow-hidden">
            <iframe 
              src="https://sites.google.com/view/tvwallmountingmelbourne/home" 
              className="w-full h-96 border-0"
              title="TV Wall Mounting Melbourne Reference"
            ></iframe>
          </div>
        </div>
      </article>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-24">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <p className="text-sm text-gray-500 text-center">
            © 2025 Practical Living Projects. <a href="https://readdy.ai/?origin=logo" className="hover:text-gray-700 transition-colors whitespace-nowrap cursor-pointer">Powered by Readdy</a>
          </p>
        </div>
      </footer>
    </div>
  );
}
